import { render } from '../../App'
import { connect } from 'react-redux'

import { Fieb } from './components/Fieb'

import { reducer } from './reducer'

const mapStateToProps = state => {
    const winners = state.winners && state.winners.asMutable({ deep: true }).tabs?.reduce((memo, item) => {
        memo = memo.concat(item.winners.map(item1 => ({ ...item1, spec: item.tabs })))
        return memo;
    }, [])

    return {
        ...state,
        winners
    }
}

const Container = connect(mapStateToProps, null)(Fieb)

render(Container, reducer)




